var util = require('util')
  , Readable = require('readable-stream').Readable;


module.exports = BlobReadStream;

util.inherits(BlobReadStream, Readable);

/**
 * Readable stream for Blob and File on browser.
 *
 * @param {Object} options
 * @api private
 */
function BlobReadStream(blob, options) {
  if (!(this instanceof BlobReadStream)) {
    return new BlobReadStream(blob, options);
  }

  Readable.call(this, options);

  this.blob = blob;
  this.slice = blob.slice || blob.webkitSlice || blob.mozSlice;
  this.start = 0;

  var fileReader = this.fileReader = new FileReader();
  fileReader.onload = this._onload.bind(this);
  fileReader.onerror = this._onerror.bind(this);
}

BlobReadStream.prototype._read = function(size) {
  var start = this.start
    , end = this.start = this.start + size
    , chunk = this.slice.call(this.blob, start, end);

  if (chunk.size) {
    this.fileReader.readAsDataURL(chunk);
  } else {
    this.push(null);
  }
};

BlobReadStream.prototype._onload = function(e) {
  // parse data from DataURL.
  var chunk = e.target.result.match(/,(.*)$/)[1];
  this.push(chunk, 'base64');
};

BlobReadStream.prototype._onerror = function(e) {
  var err = e.target.error;
  this.emit('error', err);
};




//////////////////
// WEBPACK FOOTER
// ./modules/socketapilegacy/~/socket.io-stream/lib/blob-read-stream.js
// module id = 819
// module chunks = 0